var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-brand d-flex flex-column align-items-center flex-column-auto py-3"},[_c('router-link',{attrs:{"to":`${this.$router.currentRoute.matched[0]['path'] == '/admin' ? '/admin/dashboard' : '/dashboard'}`}},[_c('img',{staticClass:"max-h-70px",attrs:{"src":_vm.siteLogo(),"alt":"Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }